<template>
  <f7-page>
    <div v-if="loaded">
      <div class="custom-table-container tableContainer">
        <MaterialRequest :store="MaterialRequestStore" />
      </div>
    </div>
  </f7-page>
</template>

<script>
import MaterialRequest from '@/components/MaterialRequest/MaterialRequest.vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import EventBus from '@/services/event-bus';

export default {
  components: {
    MaterialRequest,
  },
  data() {
    return {
      loaded: false,
      MaterialRequestStore: null,
      selectedIndex: 0,
      selectedRoute: 0,
    };
  },
  computed: {
    company() {
      return this.$store.state.contact.company;
    },
    ...mapState('materialRequest', ['solicitudesMateriales']),
    ...mapGetters('user', ['isAdmin']),
  },
  beforeMount() {
    this.setCurrentRoute([
      {
        name: this.$t('material_request'),
        disabled: false,
        page: 'MaterialRequest',
        active: true,
      },
    ]);
    this.setCurrentFilter('materialRequest');
  },
  async mounted() {
    try {
      this.$f7.preloader.show();

      this.fetchMaterialFilterOptions();

      setTimeout(() => {
        this.applyCurrentFilters();
      }, 0);

      if (!this.isAdmin) {
        this.$notifyDX(
          {
            message: this.$t('noAdminPermission'),
            width: 550,
          },
          'error'
        );
      }

      EventBus.$on('MaterialRequest', async (estado) => {
        const activeFilters = Array.isArray(estado) ? estado : [];
        await this.fetchSolicitudesMateriales(activeFilters);
        this.MaterialRequestStore = this.solicitudesMateriales.map(
          (item) => ({
            ...item,
            PlazoEntrega: '48h-72h',
          })
        );
      });
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(
              JSON.parse(error.message).error
            )
          ),
          width: 550,
        },
        'error'
      );
    } finally {
      this.$f7.preloader.hide();
      this.loaded = true;
    }
  },
  beforeDestroy() {
    EventBus.$off('MaterialRequest');
  },
  methods: {
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('materialRequest', [
      'fetchSolicitudesMateriales',
      'setSolicitudesMateriales',
    ]),
    ...mapActions('filter', [
      'setCurrentFilter',
      'applyCurrentFilters',
    ]),
    ...mapActions('materialRequestFilters', [
      'fetchMaterialFilterOptions',
    ]),
  },
  watch: {
    async company(newVal, oldVal) {
      if (newVal !== oldVal) {
        try {
          this.setSolicitudesMateriales([]);
          await this.fetchSolicitudesMateriales();
          this.MaterialRequestStore =
            this.solicitudesMateriales.map((item) => ({
              ...item,
              PlazoEntrega: '48h-72h',
            }));
        } catch (error) {
          this.$notifyDX(
            {
              message: this.$t(
                this.$helpers.getFilteredErrorMessage(
                  JSON.parse(error.message).error
                )
              ),
              width: 550,
            },
            'error'
          );
        } finally {
          this.$f7.preloader.hide();
        }
      }
    },
  },
};
</script>
